import Heading from "components/Heading/Heading";
import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import useWindowSize from "hooks/useWindowResize";
import { useTranslation } from "react-i18next";
import { CDN_BASE_URL } from "utils/constants";
import useRequest from "hooks/useRequest";
import Loading from "shared/Loading/Loading";

export interface SectionCostumerPortfolioProps {
  className?: string;
  gridClassName?: string;
  lang: string;
}

const SectionCostumerPortfolio: React.FC<SectionCostumerPortfolioProps> = ({
  className = "",
  lang,
}) => {
  const [t] = useTranslation("global");

  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  const [pageData, setPageData] = useState<any | null>(null);
  const { response, error, loading } = useRequest({
    url: `/client-portfolio?&locale=${lang}&populate=deep`,
    method: "get",
  });

  useEffect(() => {
    if (response && response.data) {
      setPageData(response.data.data.attributes);
    }
  }, [response]);

  if (loading) {
    return (
      <div className="container relative py-16">
        <Loading />
      </div>
    );
  }

  if (!pageData || error) {
    return;
  }

  const { title, description, client } = pageData;

  return (
    <div className={`section-costumer-portfolio relative ${className}`}>
      <Heading
        isWhite
        headSignature
        desc={description}
        className="mb-4 container"
      >
        {title}
      </Heading>
      {WIN_WIDTH > 768 ? (
        <div className="md:container flex lg:grid grid-cols-12 content-between overflow-x-auto no-scrollbar">
          {client.map((item: any, i: number) => (
            <div
              className="flex justify-center flex-shrink-0 self-center first:pl-5 last:pr-5 md:first:pl-0 md:last:pr-0 w-[150px] lg:max-w-[100px] lg:w-fit"
              key={i}
            >
              <img
                src={CDN_BASE_URL + item.logo.data.attributes.url}
                alt={item.logo.data.attributes.caption}
                className="max-h-[100px]"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      ) : (
        <Splide
          options={{
            type: "loop",
            drag: "free",
            focus: "center",
            arrows: false,
            pagination: false,
            perPage: 2.5,
            autoScroll: {
              pauseOnHover: false,
              pauseOnFocus: false,
              speed: 1,
            },
          }}
          extensions={{ AutoScroll }}
        >
          {client.map((item: any, i: number) => (
            <SplideSlide key={i}>
              <img
                src={CDN_BASE_URL + item.logo.data.attributes.url}
                alt={item.logo.data.attributes.caption}
                className="max-h-[150px] max-w-[150px] lg:max-w-[100px] self-center"
                loading="lazy"
              />
            </SplideSlide>
          ))}
        </Splide>
      )}
    </div>
  );
};

export default SectionCostumerPortfolio;
